/**
 * Created by Daniela on 26/09/2016.
 */
import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { GruposMateriaisRoutingModule } from "./grupos-materiais.routing";
import { GrupoMaterialService } from "./shared/grupo-material.service";
import { GrupoMaterialApiService } from "./shared/grupo-material-api.service";
import { GrupoMaterialNavigationService } from "./shared/grupo-material-navigation.service";
import { GruposMateriaisComponent } from "./grupos-materiais.component";
import { GrupoMaterialFormComponent } from "./grupo-material-form/grupo-material-form.component";
import { GrupoMaterialListComponent } from "./grupo-material-list/grupo-material-list.component";

@NgModule({
  imports: [
    SharedModule,
    GruposMateriaisRoutingModule
  ],
  providers: [
    GrupoMaterialService,
    GrupoMaterialApiService,
    GrupoMaterialNavigationService
  ],
  declarations: [
    GruposMateriaisComponent,
    GrupoMaterialFormComponent,
    GrupoMaterialListComponent
  ]
})
export class GruposMateriaisModule {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/grupos-materiais/grupos-materiais.module.ts
 **/